import React, { useState } from 'react'
import { useHistory, useParams } from "react-router-dom";
import styled from 'styled-components'
import MenuIcon from '../Icons/Menu/Menu'
import AvailableOfflineIcon from '../Icons/AvailableOffline/AvailableOffline'
import UnavailableOfflineIcon from '../Icons/AvailableOffline/UnavailableOffline'
import LikeIcon from '../LikeIcon/LikeIcon'
import { Black, Dark, Gray20, Gray25, White } from '../../Constants/ColorChart'
import TrashIcon from '../Icons/Trash/Trash';
import InformationItem from "./Components/InformationalItem/InformationItem";
import LinkIcon from "../Icons/Link/Link";
import isElectron from 'is-electron'
import { PLAYLIST_QUERY } from "../Playlist/Queries/PlaylistQuery";
import { BackendURL } from "../../Constants/AppData";
import { connect } from "react-redux";
import { addItemToQueue, addPlaylistToDownloadQueue } from "../../../actions/downloadManager";
import { showDialog } from "../../../actions/ui";
import { useQuery } from "@apollo/client";
import { triggerItemStoreAnalytics } from "../../../../web/Utils/utils";

let electron;
if ( isElectron() ) {
    electron = window.require( "electron" )
}
const ipcRenderer = electron && electron.ipcRenderer;

/*
 *  @Description:   Stateless component that is used to present one or more InformationalItem.
 */

const ActionWrapper = styled.div`
    padding-bottom: 20px;
`

const StyledRow = styled.div`
	display: flex;
	.shareWrapper {
	    position: relative;
	    &.playlist .ShareLinkToggler svg {
	        fill: transparent;
	    }
	    .ShareLinkToggler svg {
	        stroke-width: 2px;
	    }
	}
    .ShareLink {
        position: absolute;
        bottom: -95px;
        background: ${ White };
        padding: 10px 20px;
        border: 0.5px solid ${ Gray25 };
        z-index: 1;
        right: 0;
        font-size: 16px;
        min-width: 300px;
        color: ${ Black };
        &-title {
            display: block;
            text-align: left;
        }
        &-close {
            position: absolute;
            top: 6px;
            right: 10px;
            cursor: pointer;
        }
        input {
            width: 100%;
        }
        .disappear {
            opacity: 0;
            transition: opacity 400ms;
        }
    }
    .ShareLink:before {
        content: " ";
        display: block;
        position: absolute;
        width: 12px;
        height: 12px;
        background: ${ White };
        top: -6px;
        right: 55px;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
        z-index: -1;
        box-shadow: -1.5px -1.5px ${ Gray20 };
    }
`;

const locationOrigin = isElectron() ? process.env.REACT_APP_SITE_URL : window.location.origin

const ResourceInformation = ( props ) => {
    const id = useParams().id;
    const [ playlistData, setPlaylistData ] = useState( null );
    const history = useHistory();
    const {
        iconColor,
        elementCounter,
        isFav,
        availableOffline,
        showElementCounter,
        showFav,
        showShareLink,
        showAvailableOffline,
        itemId,
        itemName,
        playlist,
        resource,
        isInPlaylist,
        title,
        goBack,
    } = props;


    const { data, error } = useQuery( PLAYLIST_QUERY, {
        variables: { "id": String(id) },
        options: { "errorPolicy": "ignore" }
    } );

    if ( error ) {
        console.error( "Error in response for 'playlistQuery' in 'downloadPlaylist': ", error )
    }
    if ( data && data.nodeById && !playlistData ) {
        setPlaylistData( data.nodeById );

    }

    const storePlaylist = ( playlistId ) => {
        // console.info("downloadPlaylist clicked");
        if ( playlistData ) {
            props.addPlaylistToDownloadQueue( playlistId );

            const info = {
                id: playlistData.nid,
                name: playlistData.title,
                type: "playlist"
            }
            props.addItemToQueue( info );
            const playlistExtendedData = { ...playlistData, backendURL: BackendURL }
            ipcRenderer.send( "storePlaylistMetadata", playlistExtendedData );
            triggerItemStoreAnalytics( info, props.session.user );
        }
    }

    const storeResource = (item) => {
        let resource = item.processedResource;
        resource.sessionToken = props.session.token;
        ipcRenderer.invoke('CreateResource', resource);

        const info = {
            id: resource.id,
            name: resource.metadata.name,
            type: resource.type,
            index: resource.metadata.fileIndex
        };

        triggerItemStoreAnalytics(info, props.session.user);
    }

    const toggleShareLink = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const shareLink = document.querySelectorAll( "#headerShare" )[0].classList;
        const shownLinks = document.querySelectorAll( ".show" );

        if ( shareLink.contains( "d-none" ) ) {

            if ( shownLinks.length > 0 ) {
                shownLinks.forEach(
                    ( element ) => {
                        element.classList.remove( "show" );
                        element.classList.add( "d-none" );
                    } )
            }

            shareLink.remove( "d-none" );
            shareLink.add( "show" );
        } else {
            shareLink.remove( "show" );
            shareLink.add( "d-none" );
        }

        const inputLink = document.querySelectorAll( "#input-header" )[0];
        inputLink.focus();
        inputLink.select();
        inputLink.setSelectionRange( 0, 99999 ); /*For mobile devices*/
        document.execCommand( "copy" );
    }

    const showDialog = ( data ) => {
        props.showDialog( data )
    }

    const removeItem = ( data ) => {
        const { event, type, itemId, title, callback } = data;
        event.preventDefault();
        // console.info( "Delete " + row.id );

        showDialog( {
            dialogTitle: "Deleting " + type,
            dialogBody: [ "This will delete the following " + type + ":", title, "This action cannot be undone!" ],
            onAccept: {
                channel: type === "playlist" ? "deletePlaylist" : "deleteResource",
                args: type === "playlist" ? itemId : { resources: Array.isArray( itemId ) ? itemId[0] : itemId }
            },
            callback
        } )
    }

    return (
        <ActionWrapper>
            <StyledRow>
                {
                    showElementCounter &&
                    <div>
                        <InformationItem
                            Icon={ MenuIcon }
                            color={ iconColor }
                            reducedText={ elementCounter }
                            text={ elementCounter + (elementCounter > 1 ? " elements" : " element") }
                        />
                    </div>
                }
                {
                    showFav && isFav !== null &&
                    <div>
                        <LikeIcon
                            isResourceInformation={ true }
                            width="18px"
                            activeStyle={ `fill: ${ iconColor }; stroke: ${ iconColor }; &:hover{ cursor: pointer }; flex-shrink: 0; stroke-width: 2px` }
                            unactiveStyle={ `fill: none; stroke: ${ iconColor }; &:hover{ cursor: pointer }; flex-shrink: 0; stroke-width: 2px` }
                            active={ isFav }
                            itemId={ playlist ? playlist.id : resource.id }
                            likeId={ playlist ? playlist.id : resource.id }
                            itemName={ itemName }
                            entityBundle={ playlist ? "playlist" : "resource" }
                        />
                    </div>
                }
                {
                    showShareLink && itemId &&
                    <div className={ playlist ? "shareWrapper playlist" : "shareWrapper" }>
                        <div className="ShareLink d-none" id="headerShare">
                    <span className="ShareLink-close" onClick={ (event) => {
                        toggleShareLink( event )
                    } }>✕</span>
                            <label className="ShareLink-title">Share Link</label>
                            <input type="text" id="input-header" value={ locationOrigin + "/link/" + itemId } readOnly/>
                            <small className="smallText">Link copied to your Clipboard!</small>
                        </div>
                        <div
                            className="ShareLinkToggler"
                            style={ { cursor: "pointer" } }
                            onClick={ (event) => toggleShareLink( event ) }
                        >
                            <InformationItem
                                Icon={ LinkIcon }
                                isFilled={ false }
                                alwaysShowText={ true }
                                text={ "Share" }
                                color={ iconColor }
                            />
                        </div>
                    </div>
                }
            </StyledRow>
            <StyledRow>
                {
                    isElectron() &&
                    availableOffline &&
                    showAvailableOffline &&
                    <div>
                        <InformationItem
                            Icon={ AvailableOfflineIcon }
                            isFilled={ true }
                            isResource={ resource }
                            color={ resource ? White : Dark }
                            fillColor={ iconColor }
                            alwaysShowText={ true }
                            text="Available offline"
                        />
                    </div>
                }
                {
                    isElectron() &&
                    availableOffline &&
                    showAvailableOffline &&
                    !isInPlaylist &&
                    <div>
                        <InformationItem
                            Icon={ TrashIcon }
                            isFilled={ false }
                            isResource={ false }
                            color={ iconColor }
                            alwaysShowText={ true }
                            text="Remove from offline storage"
                            onClick={ ( event ) => {
                                const obj = {
                                    event,
                                    type: playlist ? "playlist" : "resource",
                                    itemId,
                                    title,
                                    callback: goBack ? () => {
                                        history.go( -1 )
                                    } : null,
                                }

                                removeItem( obj );
                            } }
                        />
                    </div>
                }
                {
                    isElectron() && !availableOffline && showAvailableOffline &&
                    <div>
                        <InformationItem
                            Icon={ UnavailableOfflineIcon }
                            isFilled={ false }
                            isResource={ resource }
                            color={ iconColor }
                            alwaysShowText={ true }
                            text="Not available offline"
                            onClick={ () => {
                                playlist ? storePlaylist( itemId ) : storeResource( resource )
                            } }
                        />
                    </div>
                }
            </StyledRow>
        </ActionWrapper>
    )
}

const mapStateToProps = ( state ) => ({
    dialogVisible: state.ui.dialogVisible,
    session: state.session,
});

export default connect( mapStateToProps, {
    addItemToQueue,
    showDialog,
    addPlaylistToDownloadQueue,
} )( ResourceInformation );